'use-strict';

import { IScope } from 'angular';
import { CommentAPIService } from '../../../shared/api/comment-api.service';
import { NumberConversionService } from '../../../shared/converter/number-converter.service';
import { Comment, ECommentContext, ECommentType } from '../../../src/app/@shared-types/misc/comment';
import LogService from '../../../src/app/shared/services/log';
import { ToastService, ToastType } from '../../toast/toast.service';

interface CommentType {
  id: string,
  value: string,
  icon: string,
  title: string,
  hover: string,
}

interface CommentFormScope extends IScope {
  context: string,
  contextId: string,
  placeholder?: string,
  selectedTypes?: string[],
  commentTypes: CommentType[],
  placeholderText: string,
  addComment: () => void,
  newComment: Partial<Comment>,
  showSubmitButton: boolean,
}

/* @ngInject */
export default function CommentFormController(
  $rootScope: IScope,
  $scope: CommentFormScope,
  commentApiService: CommentAPIService,
  numberConversionService: NumberConversionService,
  toastService: ToastService,
  logService: LogService,
): void {
  const commentTypesByContext = (context: ECommentContext): CommentType[] | null => {
    let commentTypes = null;

    switch (context) {
      case ECommentContext.VEHICLE:
        commentTypes = [{
          id: numberConversionService.generateUUID(),
          value: 'general',
          icon: 'fad fa-comments',
          title: 'Allgemeiner Kommentar',
          hover: 'Wird nur in der Seitenleiste angezeigt.',
        }, {
          id: numberConversionService.generateUUID(),
          value: 'important',
          icon: 'fad fa-exclamation-circle',
          title: 'Wichtige Information',
          hover: 'Wird zusätzlich in der Fahrzeugübersicht dargestellt.',
        }, {
          id: numberConversionService.generateUUID(),
          value: 'accessories',
          icon: 'fad fa-tire',
          title: 'Zubehör',
          hover: 'Wird zusätzlich in der Fahrzeugübersicht hervorgehoben.',
        }, {
          id: numberConversionService.generateUUID(),
          value: 'funding',
          icon: 'fad fa-euro-sign',
          title: 'Verkaufsförderung',
          hover: 'Wird bei den Preisdaten angezeigt.',
        }];
        break;
      default:
        commentTypes = null;
        break;
    }

    return commentTypes;
  };

  const initEmptyComment = () => {
    const commentTypes = commentTypesByContext($scope.context as ECommentContext);
    if (!commentTypes) return;

    if ($scope.selectedTypes) {
      $scope.commentTypes = commentTypes.filter((t) => $scope.selectedTypes?.includes(t.value));
    } else {
      $scope.commentTypes = commentTypes;
    }

    $scope.newComment = {
      type: $scope.commentTypes === null ? null : $scope.commentTypes[0].value as ECommentType,
    };
  };

  $scope.addComment = () => {
    commentApiService.postComment(
      $scope.context as ECommentContext,
      $scope.contextId,
      $scope.newComment,
    )
      .then(() => {
        toastService.toast(ToastType.SUCCESS, 'Kommentar gespeichert');
        $rootScope.$broadcast('updateComments');
        initEmptyComment();
        $scope.showSubmitButton = false;
      })
      .catch((e) => logService.error(e));
  };

  $scope.placeholderText = $scope.placeholder === undefined ? 'Kommentar hinzufügen...' : $scope.placeholder;

  initEmptyComment();
}
